module.exports = __webpack_public_path__ + "static/img/bankf.b51ce2d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spreader/bankf.jpg
// module id = LboA
// module chunks = 1